import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-bottom-sheet-dialog',
  templateUrl: './bottom-sheet-dialog.component.html',
  styleUrls: ['./bottom-sheet-dialog.component.scss']
})
export class BottomSheetDialogComponent implements OnInit {

  priceArray: Array<any> = [
    { type: 1, name: 'Under ₹ 1000', value: '0-1000' },
    { type: 1, name: '₹ 1000 - ₹ 5000', value: '1000-5000' },
    { type: 1, name: '₹ 5000 - ₹ 10000', value: '5000-10000' },
    { type: 1, name: '₹ 10000 - ₹ 20000', value: '10000-20000' },
    { type: 1, name: 'Over ₹ 20000', value: '20000-100000' },
  ];

  constructor(private _bottomSheetRef: MatBottomSheetRef<BottomSheetDialogComponent>) { }


  ngOnInit(): void { }

  onClose(): void {
    this._bottomSheetRef.dismiss();
  }

  openLink(idx: any): void {
    this._bottomSheetRef.dismiss(idx);
  }
}
